'use strict';
'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _create = require('babel-runtime/core-js/object/create');

var _create2 = _interopRequireDefault(_create);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _xhr = require('xhr');

var _xhr2 = _interopRequireDefault(_xhr);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _json = require('json5');

var _json2 = _interopRequireDefault(_json);

var _Logger = require('./Logger');

var _Logger2 = _interopRequireDefault(_Logger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var log = _Logger2.default.namespace('ConfigLoader');

var ConfigLoader = function () {
    function ConfigLoader() {
        (0, _classCallCheck3.default)(this, ConfigLoader);

        this.config = (0, _create2.default)(null);
        this.valReplacements = (0, _create2.default)(null);
    }

    (0, _createClass3.default)(ConfigLoader, [{
        key: 'addValueReplacement',
        value: function addValueReplacement(key, value) {
            this.valReplacements[key] = value;
            return this;
        }
    }, {
        key: 'loadFromUrl',
        value: function loadFromUrl(configUrl) {
            var _this = this;

            return new _promise2.default(function (resolve, reject) {
                (0, _xhr2.default)({ url: configUrl }, function (err, response) {
                    if (err) {
                        reject();
                        return;
                    }

                    var configObj = null;
                    try {
                        configObj = _json2.default.parse(response.body);
                    } catch (parseErr) {
                        log.error('Config ' + parseErr.message);
                        var errMsg = 'Config file error: ' + parseErr.message.replace('JSON5: ', '');

                        errMsg = errMsg.replace(/at (\d+):(\d+)/g, function (m, m1, m2) {
                            return 'line ' + m1 + ', position ' + m2;
                        });
                        reject(errMsg);
                        return;
                    }

                    _this.setConfig(configObj);
                    resolve(_this.config);
                });
            });
        }
    }, {
        key: 'loadFromObj',
        value: function loadFromObj(configObj) {
            var _this2 = this;

            return new _promise2.default(function (resolve, reject) {
                _this2.setConfig(configObj);
                resolve(_this2.config);
            });
        }
    }, {
        key: 'setConfig',
        value: function setConfig(confObj) {
            var _this3 = this;

            var walkObject = function walkObject(obj, target) {
                _lodash2.default.each(obj, function (_val, key) {
                    var val = _val;
                    if (typeof val === 'string') {
                        val = _this3.insertReplacements(val);
                        target[key] = val;
                    } else if ((typeof val === 'undefined' ? 'undefined' : (0, _typeof3.default)(val)) === 'object') {
                        target[key] = _lodash2.default.isArray(val) ? [] : {};
                        walkObject(val, target[key]);
                    } else {
                        target[key] = val;
                    }
                });
            };

            this.config = (0, _create2.default)(null);
            walkObject(confObj, this.config);
        }
    }, {
        key: 'insertReplacements',
        value: function insertReplacements(input) {
            var _this4 = this;

            var out = input;
            (0, _keys2.default)(this.valReplacements).forEach(function (k) {
                out = out.replace('{{' + k + '}}', _this4.valReplacements[k]);
            });
            return out;
        }
    }]);
    return ConfigLoader;
}();

exports.default = ConfigLoader;
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["libs"]) window._kiwi_exports["libs"] = {};
window._kiwi_exports["libs"]["ConfigLoader"]
window._kiwi_exports.libs.ConfigLoader = exports.default ? exports.default : exports;



//////////////////
// WEBPACK FOOTER
// ./src/libs/ConfigLoader.js
// module id = 9myz
// module chunks = 1